
var api = {
    urlAPI: "https://test.app-service-iron-group.com.ar/api/api/",
    urlImagenes: "https://test.app-service-iron-group.com.ar/api/Imagenes/",
    crmOportunidades: "https://test.app-service-iron-group.com.ar/api/api/crm/oportunidades",
    crmTurnos: "https://test.app-service-iron-group.com.ar/api/api/crm/turnos",
    crmMaquinas:"https://test.app-service-iron-group.com.ar/api/api/crm/maquinas",
    crmClientes:"https://test.app-service-iron-group.com.ar/api/api/crm/clientes/",
    ordenes:"https://test.app-service-iron-group.com.ar/api/api/ordenes/",
    ordenesHoras:"https://test.app-service-iron-group.com.ar/api/api/horas/",
    reporteServicio:"https://test.app-service-iron-group.com.ar/api/api/reporte/servicio/"


}

export default api